import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const ContactInfoItem: React.FC<{
  icon: React.ReactNode;
  title: string;
  content: React.ReactNode;
}> = ({ icon, title, content }) => {
  return (
    <div className="flex">
      <div className="mt-1 mr-4">{icon}</div>
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">{title}</h3>
        <div className="text-gray-600">{content}</div>
      </div>
    </div>
  );
};

const ContactInfo: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-8">
      <h3 className="text-2xl font-bold text-gray-900 mb-8">Contactez-nous</h3>
      
      <div className="space-y-8">
        <ContactInfoItem
          icon={<MapPin size={24} className="text-primary-600" />}
          title="Nos Adresses"
          content={
            <>
              <div className="mb-4">
                <p className="font-medium text-gray-800">Siège Social - Dakar</p>
                <p>123 Avenue de l'Indépendance</p>
                <p>Dakar, Sénégal</p>
              </div>
              <div>
                <p className="font-medium text-gray-800">Bureau de Londres</p>
                <p>20 Wenlock Road</p>
                <p>London, N1 7GU</p>
                <p>England</p>
              </div>
            </>
          }
        />
        
        <ContactInfoItem
          icon={<Phone size={24} className="text-primary-600" />}
          title="Téléphone"
          content={
            <>
              <p>+221 77 123 45 67</p>
              <p>+221 33 123 45 67</p>
            </>
          }
        />
        
        <ContactInfoItem
          icon={<Mail size={24} className="text-primary-600" />}
          title="Email"
          content={
            <>
              <p>hello@proxyemobility.com</p>
              <p>support@proxyemobility.com</p>
            </>
          }
        />
        
        <ContactInfoItem
          icon={<Clock size={24} className="text-primary-600" />}
          title="Horaires d'Ouverture"
          content={
            <>
              <p>Lundi - Vendredi: 9h00 - 18h00</p>
              <p>Samedi: 9h00 - 13h00</p>
              <p>Dimanche: Fermé</p>
            </>
          }
        />
      </div>
    </div>
  );
};

export default ContactInfo;